interface AnalyticsData {
  pageViews: {
    landing: number
    quiz: number
    results: number
  }
  clicks: {
    startQuiz: number
    nextQuestion: number
    backQuestion: number
    submitQuiz: number
    viewProtocol: number
  }
  lastUpdated: string
}

const ANALYTICS_KEY = 'crowncontrol_analytics'

export function getAnalytics(): AnalyticsData {
  try {
    const data = localStorage.getItem(ANALYTICS_KEY)
    if (data) {
      return JSON.parse(data)
    }
  } catch (error) {
    console.error('Failed to load analytics:', error)
  }

  return {
    pageViews: { landing: 0, quiz: 0, results: 0 },
    clicks: {
      startQuiz: 0,
      nextQuestion: 0,
      backQuestion: 0,
      submitQuiz: 0,
      viewProtocol: 0,
    },
    lastUpdated: new Date().toISOString(),
  }
}

export function trackPageView(page: 'landing' | 'quiz' | 'results') {
  try {
    const analytics = getAnalytics()
    analytics.pageViews[page]++
    analytics.lastUpdated = new Date().toISOString()
    localStorage.setItem(ANALYTICS_KEY, JSON.stringify(analytics))
  } catch (error) {
    console.error('Failed to track page view:', error)
  }
}

export function trackClick(action: keyof AnalyticsData['clicks']) {
  try {
    const analytics = getAnalytics()
    analytics.clicks[action]++
    analytics.lastUpdated = new Date().toISOString()
    localStorage.setItem(ANALYTICS_KEY, JSON.stringify(analytics))
  } catch (error) {
    console.error('Failed to track click:', error)
  }
}

export function clearAnalytics() {
  try {
    localStorage.removeItem(ANALYTICS_KEY)
  } catch (error) {
    console.error('Failed to clear analytics:', error)
  }
}
